<template>
  <v-col align="center">
    <v-progress-circular v-if="loading" size="100" indeterminate />
    <div v-if="!loading">
      <LocalAgencySeats v-if="isLocal" :seat-count="agencySeatCount" />
      <RemoteAgencySeats v-if="!isLocal" :host-type="hostType" />
    </div>
  </v-col>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RemoteAgencySeats from './RemoteAgencySeats';
import LocalAgencySeats from './LocalAgencySeats';

export default {
  name: 'SeatManagement',
  components: {
    RemoteAgencySeats,
    LocalAgencySeats
  },
  data () {
    return {
      loading: true,
      errorMessage: '',
      isLocal: true,
      hostType: 0,
      agencySeatCount: 0
    };
  },
  computed: {
    ...mapState(['agency'])
  },
  async created () {
    this.loading = true;
    if (!this.agency) {
      var response = await this.$api.getAgency();
      if (response.code !== 0) {
        this.setError({ errorMessage: `Error - Unable to get agency information. Message: ${response.message}` });
        return;
      }
      this.setAgency(JSON.parse(response.data[0]));
    }
    var agencySeatsResponse = await this.$api.getAgencySeats(this.agency.agencyId);
    if (agencySeatsResponse.code === 0) {
      var payload = JSON.parse(agencySeatsResponse.data[0]);
      this.isLocal = payload.Data[0].IsLocal;
      this.agencySeatCount = payload.Data[0].Total;
      this.hostType = payload.Data[0].HostingType;
      this.setRemoteAgencySeats(payload.Data[0].Users);
    } else if (agencySeatsResponse.data.code === 2) {
      this.errorMessage = 'Seat information not found, please contact billing';
      this.loading = false;
      return;
    } else if (agencySeatsResponse.data.code > 2) {
      this.errorMessage = 'Error retrieving seat information, please contact billing';
      this.loading = false;
      return;
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError', 'setAgency', 'setRemoteAgencySeats'])
  }
};

</script>
